import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ProcessTable from '../components/RobotsPageComponents/ProcessTable';
import MachinesTable from '../components/RobotsPageComponents/MachinesTable';
import NewWizardContainer from '../components/RobotsPageComponents/NewWizardContainer';
import GenericDataTable from '../components/Common/GenericDataTable';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";
import TelephonyWizardStepper from '../components/RobotsPageComponents/TelephonyWizardStepper';
import MachineWizardContainer from '../components/RobotsPageComponents/MachineWizardContainer';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Fab from '@mui/material/Fab';
import AddApiKey from '../components/ManagementPageComponents/AddApiKey';
import { WorkersEmptyStateInfo, TelephonyEmptyStateInfo, SkillsEmptyStateInfo, ProcessesEmptyStateInfo, ApiKeysEmptyStateInfo } from '../components/EmptyStates';
import { WorkersReadyState, TelephonyReadyState, SkillsReadyState, ProcessesReadyState, ApiKeysReadyState } from '../components/ReadyStates';


export default function Resources({ initialTab }) {


    const [tabValue, setTabValue] = useState(initialTab);
    const [isDialogOpen, setIsDialogOpen] = useState();
    const [isRefreshed, setIsRefreshed] = useState(true);


    useEffect(() => {
        console.log(isRefreshed);
        setIsRefreshed(true);
    }, [isRefreshed])

const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
};


    const handleClickOpen = () => {
        setIsDialogOpen(true)
    };

    const handleClose = () => {
        setIsDialogOpen(false)
    };


    return (isRefreshed &&
            <div>
                <Box sx={{ width: '100%' }}>
                    
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        textColor="secondary"
                        indicatorColor="secondary"
                        aria-label="robots tabs"
                    >
                        
                        <Tab value="Workers" label="Workers" />
                        <Tab value="Processes" label="Processes" />
                        <Tab value="Skills" label="Skills" />
                        <Tab value="Telephony" label="Telephony" />
                        <Tab tag={Link} to="/resources/apikeys" value="Api Keys" label="Api Keys" />
                    </Tabs>
                </Box>

                               
                {
                    tabValue == "Processes" &&
                    <>
                        

                        <ProcessTable skillCategory="process" emptyState={<ProcessesEmptyStateInfo />}></ProcessTable>
                    </>

                }
                {
                    tabValue == "Skills" &&
                    <>


                        <ProcessTable skillCategory="skill" emptyState={<SkillsEmptyStateInfo />}></ProcessTable>
                    </>

                }

                {
                    tabValue == "Workers" &&
                    <>

                        <NewWizardContainer onClose={() => setIsRefreshed(false)} title="Connect a New Worker" buttonTitle="Add New Worker" childComponent={MachineWizardContainer} ></NewWizardContainer>
                        <MachinesTable emptyState={<WorkersEmptyStateInfo />}></MachinesTable>
                    </>
                }

                {
                    tabValue == "Telephony" &&
                    <>
                        
                        <NewWizardContainer title="Add a Telephone Number" buttonTitle="Add New Number" childComponent={TelephonyWizardStepper}></NewWizardContainer>
                        <GenericDataTable pageUrl="/resources/telephony" fetchUrl={"api/getdatabase?table_name=telephony"} ovverideColumns={["number", "vendor", "agent_id", "registered_by", "create_date"]} emptyState={<TelephonyEmptyStateInfo />}
                            readyState={<TelephonyReadyState/> }> </GenericDataTable>
                    </>
                }
                {
                    tabValue == "Api Keys" &&
                    <>
                        <Dialog open={isDialogOpen} onClose={handleClose}>
                            <DialogContent>
                                <AddApiKey handleClose={handleClose}></AddApiKey>
                            </DialogContent>

                        </Dialog>

                        <Box sx={{ '& > :not(style)': { m: 1 } }}>
                            <Fab title="Add Key" className="floatRight" color="primary" aria-label="add" onClick={handleClickOpen}>
                                <AddIcon />
                            </Fab>

                        </Box>
                    <GenericDataTable refreshTrigger={isDialogOpen} deleteEndpoint={"api/key/deletekey" }  pageUrl="/resources/apikeys" fetchUrl={"api/getdatabase?table_name=keys"} ovverideColumns={["name", "vendor", "registered_by"]} emptyState={<ApiKeysEmptyStateInfo />} readyState={<ApiKeysReadyState />}> </GenericDataTable>


                    </>

                }


            </div>
        );
    }

